import {getTodayHabits} from "./get-today-habits";
import {isHabitCompleted} from "./is-habit-completed";
import {getStartEndWeek} from "./get-start-end-week";
import {getDates} from "./get-dates";

export const weeklyGoalsCount = (date, habits) => {
    let [start, end] = getStartEndWeek(date);
    let dates = getDates(start, end);

    const countDailyGoals = (total, curr) => {
      let dailyHabits = getTodayHabits(curr, habits);
      return total + dailyHabits.length;
    }

    return dates.reduce(countDailyGoals, 0);
  }

export const weeklyCompletedCount = (date, habits, checklists) => {
     let [start, end] = getStartEndWeek(date);
     let dates = getDates(start, end);

     const countCompleted = (total, curr) => {
       let todayHabits = getTodayHabits(curr, habits);
       let completedCount = todayHabits.filter(habit => isHabitCompleted(habit.id, curr, checklists)).length;
       return total + completedCount;
     }

     return dates.reduce(countCompleted, 0)
  } 

export const getWeeklyPercentage = (date, habits, checklists) => {
  let percentage = ( weeklyCompletedCount(date, habits, checklists) / weeklyGoalsCount(date, habits) ).toFixed(2)
  return isNaN(percentage) ? 0 : percentage 
}

export function getWeeklyCompletedByHabit(habit, date, checklists){
  let [start, end] = getStartEndWeek(date);
  let completedCount = getDates(start, end).filter(date => habit.recurrence.indexOf(date.getDay()) > -1 && isHabitCompleted(habit.id, date, checklists)).length;

  return completedCount;
}

export function getWeeklyPercentageByHabit(habit, date, checklists){
   return getWeeklyCompletedByHabit(habit, date, checklists) / habit.recurrence.length; 
}


